import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const MapView = ({ participants, meetingPoints, selectedLocation, onLocationSelect }) => {
  const [mapZoom, setMapZoom] = useState(14);
  const [showParticipants, setShowParticipants] = useState(true);
  const [showMeetingPoints, setShowMeetingPoints] = useState(true);

  const handleZoomIn = () => {
    setMapZoom(prev => Math.min(prev + 1, 18));
  };

  const handleZoomOut = () => {
    setMapZoom(prev => Math.max(prev - 1, 10));
  };

  const centerLat = participants?.length > 0 
    ? participants?.reduce((sum, p) => sum + p?.lat, 0) / participants?.length 
    : 40.7128;
  const centerLng = participants?.length > 0 
    ? participants?.reduce((sum, p) => sum + p?.lng, 0) / participants?.length 
    : -74.0060;

  return (
    <div className="relative w-full h-full bg-muted rounded-lg overflow-hidden">
      <iframe
        width="100%"
        height="100%"
        loading="lazy"
        title="Meeting Point Map"
        referrerPolicy="no-referrer-when-downgrade"
        src={`https://www.google.com/maps?q=${centerLat},${centerLng}&z=${mapZoom}&output=embed`}
        className="w-full h-full"
      />
      <div className="absolute top-4 right-4 flex flex-col gap-2 z-10">
        <button
          onClick={handleZoomIn}
          className="w-10 h-10 bg-card border border-border rounded-lg flex items-center justify-center text-foreground hover:bg-muted transition-smooth active-press shadow-md focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3"
          aria-label="Zoom in"
        >
          <Icon name="Plus" size={20} />
        </button>
        <button
          onClick={handleZoomOut}
          className="w-10 h-10 bg-card border border-border rounded-lg flex items-center justify-center text-foreground hover:bg-muted transition-smooth active-press shadow-md focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3"
          aria-label="Zoom out"
        >
          <Icon name="Minus" size={20} />
        </button>
      </div>
      <div className="absolute top-4 left-4 bg-card border border-border rounded-lg shadow-md p-3 z-10 max-w-[200px]">
        <h3 className="font-heading text-sm font-semibold text-foreground mb-2">Map Legend</h3>
        <div className="space-y-2">
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={showParticipants}
              onChange={(e) => setShowParticipants(e?.target?.checked)}
              className="w-4 h-4 rounded border-border text-primary focus:ring-3 focus:ring-ring focus:ring-offset-3"
            />
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 bg-primary rounded-full" />
              <span className="caption text-foreground">Participants</span>
            </div>
          </label>
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={showMeetingPoints}
              onChange={(e) => setShowMeetingPoints(e?.target?.checked)}
              className="w-4 h-4 rounded border-border text-accent focus:ring-3 focus:ring-ring focus:ring-offset-3"
            />
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 bg-accent rounded-full" />
              <span className="caption text-foreground">Meeting Points</span>
            </div>
          </label>
        </div>
      </div>
      <div className="absolute bottom-4 left-4 bg-card border border-border rounded-lg shadow-md px-3 py-2 z-10">
        <p className="caption text-muted-foreground">
          Showing {meetingPoints?.length} meeting point{meetingPoints?.length !== 1 ? 's' : ''} for {participants?.length} participant{participants?.length !== 1 ? 's' : ''}
        </p>
      </div>
    </div>
  );
};

export default MapView;